import React from "react";
import { Switch } from "@progress/kendo-react-inputs";
import { Popup } from "@progress/kendo-react-popup";
import { action, label } from "../../config";

/**
 * NotificationPopup component displays a popup for toggling push and email notifications for a project.
 * @author Bhavana
 */
const NotificationPopup = ({ anchor, show, onClose, pushEnabled, emailEnabled, onPushChange, onEmailChange }) => {
  const handleContentClick = (e) => {
    e.stopPropagation();
  };

  return (
    <Popup anchor={anchor} show={show} popupClass='' animate={true} onClose={onClose} className='z-3' popupAlign={{ horizontal: "center", vertical: "top" }}>
      <div className='notification-popup-content p-3' onClick={handleContentClick}>
        <div className='d-flex align-items-center mb-3'>
          <span className=''>{label?.NOTIFICATIONS}</span>
        </div>
        <div className='d-flex flex-column'>
          <div className='d-flex align-items-center mb-2'>
            <span className='mr-2 min-width-60'>{label?.PUSH}</span>
            <Switch checked={pushEnabled} onChange={onPushChange} />
          </div>
          <div className='d-flex align-items-center'>
            <span className='mr-2 min-width-60'>{label?.EMAILS}</span>
            <Switch checked={emailEnabled} onChange={onEmailChange} />
          </div>
        </div>
      </div>
    </Popup>
  );
};

export default NotificationPopup;
